export const useStyles = theme => ({
  completeRoot: {
    width: '60%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      padding: '10px',
    },
  },
  completeHeader: {
    font: 'normal normal 900 60px/72px Maax-Black',
    color: '#fff',
    marginBottom: '20px',
    marginTop: '8%',
    [theme.breakpoints.down('md')]: {
      font: 'normal normal 900 40px/50px Maax-Black',
    },
  },
  completeText: {
    font: 'normal normal 20px/36px Maax-Medium',
    color: '#fff',
    [theme.breakpoints.down('md')]: {
      font: 'normal normal 900 18px/30px Maax-Black',
    },
  },

  completeButton: {
    color: '#0D6A41',
    backgroundColor: '#B4C64C',
    width: '60%',
    borderRadius: '10px',
    font: 'normal normal 20px/36px Maax-Bold',
    marginTop: '20px',
    '&:hover': {
      backgroundColor: '#B4C64C',
    },
  },
});
